<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <!-- filter button -->
          <v-btn class="mr-2" large v-on="on" :class="{'teal--text':filter.active}">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filter</v-card-title>
            <v-divider />
            <v-card-text>
              <!-- <v-text-field
                v-model="filter.data.nomor"
                hide-details
                outlined
                placeholder="Nomor"
                label="Nomor"
              ></v-text-field>-->
              <v-autocomplete
                class="mb-3"
                v-if="!$acl.check('isSekolah')"
                v-model="filter.data.sekolah"
                :items="list.sekolah.data"
                name="Sekolah"
                label="Sekolah"
                dense
                placeholder="Sekolah"
                item-text="Nama"
                item-value="IDSekolah"
                outlined
                hide-details
                multiple
                hide-selected
                deletable-chips
                chips
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          class="mt-n1"
                          :color="data.item.Tipe=='negeri'?'blue':'green'"
                          x-small
                        >mdi-checkbox-blank-circle</v-icon>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="grey--text text--lighten-1"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.Alamat + ' ' +  data.item.Lokasi + ' ' +  data.item.Provinsi"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-daterange
                v-model="filter.data.tanggal"
                presetLabel="Periode"
                name="Periode"
                label="Periode"
                startLabel="Periode Awal"
                endLabel="Periode Akhir"
                display-format="dd-MM-yyyy"
                no-title
                dense
                :action-labels="{ apply: 'Terapkan' }"
              ></v-daterange>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <!-- <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>-->
      <v-spacer />

      <!-- grid button -->
      <v-btn
        class="ml-2"
        color="cyan white--text"
        large
        to="/transaksi/baru"
        v-if="$acl.check('isSwasta')"
      >
        <span class="hidden-xs-only" v-text="app.grid.create"></span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- grid -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      multi-sort
      class="elevation-1"
    >
      <!-- custom handling -->
      <template v-slot:item.Tanggal="{ item }">{{item.Tanggal | date}}</template>
      <template v-slot:item.Sekolah="{ item }">
        <v-list-item three-line class="px-0" dense>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                class="mt-n1"
                :color="item.Sekolah.Tipe=='negeri'?'blue':'green'"
                x-small
              >mdi-checkbox-blank-circle</v-icon>
              {{item.Sekolah.Nama}}
              &mdash;
              <span
                class="grey--text text--lighten-1"
              >{{item.Sekolah.Kode}}</span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.Sekolah.Alamat}} {{ item.Sekolah.Lokasi}} {{item.Sekolah.Provinsi}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:item.NominalPenerimaan="{ item }">
        <v-chip color="success" small outlined>
          <v-icon small left>mdi-wallet</v-icon>
          {{item.NominalPenerimaan | currency}}
        </v-chip>
      </template>

      <template v-slot:item.NominalBelanja="{ item }">
        <v-chip color="primary" small outlined>
          <v-icon small left>mdi-cart</v-icon>
          {{item.NominalBelanja | currency}}
        </v-chip>
      </template>
      <template v-slot:item.SP2B="{ item }">{{(!!item.SP2B)? item.SP2B.Nomor : "-"}}</template>

      <!-- custom updated date & by -->
      <template v-slot:item.LastUpdatedDate="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
          </template>
          <span>{{$format.updatedDate(item)}}</span>
        </v-tooltip>
      </template>

      <!-- grid header -->
      <template v-slot:header.Actions>
        <div class="float-right">
          <v-btn icon v-if="filter.active" :class="{'mr-4':sort.active}" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
          <v-btn icon v-if="sort.active" @click="clearSort">
            <v-icon>mdi-sort-variant-remove</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- grid actions -->
      <template v-slot:item.Actions="{ item }">
        <div class="float-right">
          <span v-if="item.ETLID || item.Terkunci || (!item.ETLID && item.IDSP2B)">
            <v-btn icon color="blue" @click="viewItem(item)">
              <v-icon>mdi-folder-open-outline</v-icon>
            </v-btn>
          </span>
          <span v-if="!(item.ETLID || item.Terkunci || (!item.ETLID && item.IDSP2B))">
            <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :loading="item.processing">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="deleteItem(item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Hapus</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      filter: {
        dialog: false,
        active: false,
        data: {
          nomor: "",
          sekolah: [],
          tanggal: {}
        },
        query: {}
      },
      sort: {
        active: false
      },
      search: {
        awaiting: false,
        data: ""
      },
      table: {
        awaiting: false
      },
      loading: false,
      options: {},
      headers: [
        {
          value: "Tanggal",
          text: "Tanggal",
          width: "10%"
        },
        {
          value: "Sekolah",
          text: "Sekolah",
          width: "30%"
        },
        {
          value: "NominalPenerimaan",
          text: "Penerimaan",
          width: "10%"
        },
        {
          value: "NominalBelanja",
          text: "Belanja",
          width: "10%"
        },
        {
          value: "SP2B",
          text: "SP2B",
          width: "15%"
        },
        {
          value: "LastUpdatedDate",
          text: "Terakhir Diubah",
          width: "15%"
        },
        {
          value: "Actions",
          sortable: false,
          width: "10%"
        }
      ],
      items: [],
      totalItems: 0
    };
  },
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isSekolahLoading"])
  },
  components: {
    VDaterange: () =>
      import(/* webpackChunkName: "Rekening" */ "@/components/VDaterange.vue")
  },
  methods: {
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;

      // inject sekolah
      if (this.$util.isEmpty(payload.Filter)) {
        if (this.$acl.check("isSekolah")) {
          let filter = new this.$dbflex();
          let user = this.$session.get.user();
          filter.eq("IDSekolah", user.idSekolah);
          payload.Filter = filter.get();
        }
      }

      payload.KeywordFields = ["Nomor"];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);

      if (payload.Orders.length == 0) payload.Orders = ["-LastUpdatedDate"];

      this.$axios
        .post("/report/transaksi/list", payload)
        .then(res => {
          const result = res.data;

          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async editItem(item) {
      this.$router.push(`transaksi/${item.ID}`);
    },
    async viewItem(item) {
      this.$router.push(`transaksi/${item.ID}`);
    },

    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        item.processing = true;
        this.$axios
          .delete(`/report/transaksi/${item.ID}`)
          .then(res => {
            if (res.data.Success) {
              this.$dialog.notify.success(res.data.Message, {
                ...this.app.notification
              });
            }
            this.getItems();
          })
          .catch(error => {
            this.$dialog.notify.error(error, {
              position: this.app.notification.position
            });
          })
          .finally(() => {
            item.processing = false;
          });
      }
    },
    doFilter() {
      let filter = new this.$dbflex();
      let data = this.filter.data;
      let startDate = !data.tanggal.start
        ? ""
        : moment(data.tanggal.start).utc();
      let endDate = !data.tanggal.end ? "" : moment(data.tanggal.end).utc();

      // inject sekolah
      if (this.$acl.check("isSekolah")) {
        let user = this.$session.get.user();
        filter.eq("IDSekolah", user.idSekolah);
      }

      if (data.sekolah.length > 0) {
        filter.in("IDSekolah", data.sekolah);
      }
      if (startDate != "" && endDate != "") {
        filter.gte("Tanggal", startDate);
        filter.lte("Tanggal", endDate);
      }

      let query = filter.get();
      if (query) {
        this.filter.dialog = false;
        this.filter.active = true;
        this.filter.query = query;
        this.search.data = "";
        this.getItems();
      }
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = null;
      this.search.data = "";
      this.getItems();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    },
    ...mapActions("list", ["refreshSekolah"])
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },
      deep: true
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    }
  },
  created() {},
  mounted() {
    this.refreshSekolah();
  }
};
</script>

<style>
</style>